import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@washingtonpost/wpds-icon";
import { Button } from "@washingtonpost/wpds-button";
import Volume from "@washingtonpost/wpds-assets/asset/volume";
import Mute from "@washingtonpost/wpds-assets/asset/mute";
import "./index.css";

const SoundIcon = ({ isMuted, isMiniPlayer }) => {
  return (
    <Icon fill="white" size={isMiniPlayer ? "100" : "150"} label="mute">
      {isMuted ? <Mute /> : <Volume />}
    </Icon>
  );
};

SoundIcon.propTypes = {
  isMuted: PropTypes.bool,
  isMiniPlayer: PropTypes.bool
};

export const SoundButton = ({
  isMuted = false,
  toggleMute,
  isMiniPlayer = false,
  buttonStyles
}) => {
  return (
    <Button
      aria-label={isMuted ? "Unmute audio" : "Mute audio"}
      className={"focus-visible-highlight"}
      data-testid="sound-button"
      variant="primary"
      css={{
        border: "none",
        background: "none",
        padding: "0px",
        cursor: "pointer",
        justifySelf: "end",
        ...(buttonStyles && { ...buttonStyles }),
        "&:hover": {
          background: "none",
          right: "0px"
        }
      }}
      onClick={e => {
        e.stopPropagation();
        toggleMute();
      }}
    >
      <SoundIcon {...{ isMuted, isMiniPlayer }} />
    </Button>
  );
};

SoundButton.displayName = "SoundButton";

export const toggleMuteProp = {
  toggleMute: PropTypes.func,
  isMiniPlayer: PropTypes.bool
};

SoundButton.propTypes = {
  ...toggleMuteProp
};
